module.exports = __webpack_public_path__ + "179a5ca82455483f6cda708cbef27c9c.MP3";